(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405,2199,9751,8325],{

/***/ 35498:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(2331);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoadMore; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3949);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8303);



function LoadMore(param) {
    let { children , onClick , loading =false , size ="large"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: "button",
        className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loadMore), " ").concat(size === "small" ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_1___default().small) : (_button_module_scss__WEBPACK_IMPORTED_MODULE_1___default().large)),
        disabled: loading,
        onClick: onClick,
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            size: 21
        }) : children
    });
}


/***/ }),

/***/ 12651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51834);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34741);
/* harmony import */ var constants_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30300);
/* harmony import */ var contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85286);





function SEO(param) {
    let { title , description =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_DESCRIPTION */ .KM , image =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_IMAGE */ .T5 , keywords =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_KEYWORDS */ .cU  } = param;
    const { settings  } = (0,contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__/* .useSettings */ .r)();
    const projectTitle = (settings === null || settings === void 0 ? void 0 : settings.title) || constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_TITLE */ .k5;
    const currentURL = constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .WEBSITE_URL */ .o6;
    const siteTitle = title ? title + " | " + projectTitle : projectTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "Website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                property: "og:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                property: "og:author",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: (settings === null || settings === void 0 ? void 0 : settings.favicon) || "/favicon.png"
            })
        ]
    });
}


/***/ }),

/***/ 29751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ShopCategoryList; }
});

// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23934);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/Skeleton/Skeleton.js + 3 modules
var Skeleton = __webpack_require__(57238);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(59108);
// EXTERNAL MODULE: ./components/categoryCard/v1.module.scss
var v1_module = __webpack_require__(80428);
var v1_module_default = /*#__PURE__*/__webpack_require__.n(v1_module);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/image.js
var next_image = __webpack_require__(71415);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/link.js
var next_link = __webpack_require__(36291);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/router.js
var router = __webpack_require__(49369);
;// CONCATENATED MODULE: ./components/categoryCard/v1.tsx






function CategoryCard(param) {
    let { data  } = param;
    var ref, ref1;
    const { query  } = (0,router.useRouter)();
    const handleQuery = (categoryId)=>{
        if (Number(query === null || query === void 0 ? void 0 : query.category_id) === categoryId) {
            return {
                ...query,
                category_id: undefined
            };
        }
        return {
            ...query,
            category_id: categoryId
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: {
            query: handleQuery(data === null || data === void 0 ? void 0 : data.id)
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((v1_module_default()).card, " ").concat(Number(query === null || query === void 0 ? void 0 : query.category_id) === (data === null || data === void 0 ? void 0 : data.id) ? (v1_module_default()).active : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    width: 30,
                    height: 30,
                    className: (v1_module_default()).img,
                    alt: data === null || data === void 0 ? void 0 : (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title,
                    src: (data === null || data === void 0 ? void 0 : data.img) || ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (v1_module_default()).text,
                    children: data === null || data === void 0 ? void 0 : (ref1 = data.translation) === null || ref1 === void 0 ? void 0 : ref1.title
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/swiper@8.4.7/node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(86343);
// EXTERNAL MODULE: ./containers/shopCategoryList/v1.module.scss
var shopCategoryList_v1_module = __webpack_require__(58532);
var shopCategoryList_v1_module_default = /*#__PURE__*/__webpack_require__.n(shopCategoryList_v1_module);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react-i18next@12.3.1_i18next@22.5.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(82807);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/swiper@8.4.7/node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(13866);
;// CONCATENATED MODULE: ./containers/shopCategoryList/v1.tsx









function ShopCategoryList(param) {
    let { data , loading , parent  } = param;
    const { t  } = (0,es/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (shopCategoryList_v1_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (shopCategoryList_v1_module_default()).title,
                children: t("categories")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: !loading && (data === null || data === void 0 ? void 0 : data.length) === 0 ? "none" : "block",
                    background: "var(primary-bg)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                    className: "full-width",
                    modules: [
                        swiper_esm/* Navigation */.W_
                    ],
                    navigation: true,
                    slidesPerView: "auto",
                    spaceBetween: 10,
                    children: [
                        !!parent && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            style: {
                                maxWidth: "max-content"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/shop-category/".concat(parent),
                                shallow: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shopCategoryList_v1_module_default()).card,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (shopCategoryList_v1_module_default()).text,
                                        children: t("all")
                                    })
                                })
                            })
                        }),
                        loading ? Array.from(Array(10).keys()).map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: (shopCategoryList_v1_module_default()).swiperSlide,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    className: (shopCategoryList_v1_module_default()).shimmer
                                })
                            }, item)) : data === null || data === void 0 ? void 0 : data.map((category)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: (shopCategoryList_v1_module_default()).swiperSlide,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryCard, {
                                    data: category,
                                    parent: parent
                                })
                            }, category.id))
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 2331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ HomePage; }
});

// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23934);
// EXTERNAL MODULE: ./components/seo.tsx
var seo = __webpack_require__(12651);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react-query@3.39.3_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-query/es/index.js
var es = __webpack_require__(65084);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react-i18next@12.3.1_i18next@22.5.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-i18next/dist/es/index.js + 17 modules
var dist_es = __webpack_require__(82807);
// EXTERNAL MODULE: ./services/shop.ts
var shop = __webpack_require__(99649);
// EXTERNAL MODULE: ./services/category.ts
var category = __webpack_require__(60815);
// EXTERNAL MODULE: ./services/banner.ts
var banner = __webpack_require__(67721);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/qs@6.15.1/node_modules/qs/lib/index.js
var lib = __webpack_require__(92565);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/router.js
var router = __webpack_require__(49369);
// EXTERNAL MODULE: ./containers/homev1/homev1.module.scss
var homev1_module = __webpack_require__(51603);
var homev1_module_default = /*#__PURE__*/__webpack_require__.n(homev1_module);
// EXTERNAL MODULE: ./contexts/auth/auth.context.tsx
var auth_context = __webpack_require__(92879);
// EXTERNAL MODULE: ./containers/banner/banner.module.scss
var banner_module = __webpack_require__(75166);
var banner_module_default = /*#__PURE__*/__webpack_require__.n(banner_module);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/swiper@8.4.7/node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(86343);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/link.js
var next_link = __webpack_require__(36291);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/bannerSingle/bannerSingle.module.scss
var bannerSingle_module = __webpack_require__(91644);
var bannerSingle_module_default = /*#__PURE__*/__webpack_require__.n(bannerSingle_module);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/image.js
var next_image = __webpack_require__(71415);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/bannerSingle/bannerSingle.tsx




function BannerSingle(param) {
    let { data  } = param;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/promotion/".concat(data.id),
        className: (bannerSingle_module_default()).banner,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (bannerSingle_module_default()).wrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                fill: true,
                priority: true,
                src: data === null || data === void 0 ? void 0 : data.img,
                alt: (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title,
                quality: 90,
                sizes: "(max-width: 376px) 340px, (max-width: 568px) 550px, (768px) 740px, (max-width: 992px) 960px, (max-width:1200px) 1160px, 1440px"
            })
        })
    });
}

// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(59108);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/ArrowRightSLineIcon.js
var ArrowRightSLineIcon = __webpack_require__(90910);
var ArrowRightSLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowRightSLineIcon);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/ArrowLeftSLineIcon.js
var ArrowLeftSLineIcon = __webpack_require__(56377);
var ArrowLeftSLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowLeftSLineIcon);
// EXTERNAL MODULE: ./components/carouselArrows/carouselArrows.module.scss
var carouselArrows_module = __webpack_require__(46622);
var carouselArrows_module_default = /*#__PURE__*/__webpack_require__.n(carouselArrows_module);
;// CONCATENATED MODULE: ./components/carouselArrows/carouselArrows.tsx






function NextButton() {
    const swiper = (0,swiper_react/* useSwiper */.oc)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: "".concat((carouselArrows_module_default()).btn, " ").concat((carouselArrows_module_default()).next),
        onClick: ()=>swiper.slideNext(),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightSLineIcon_default()), {})
    });
}
function PrevButton() {
    const swiper = (0,swiper_react/* useSwiper */.oc)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: "".concat((carouselArrows_module_default()).btn, " ").concat((carouselArrows_module_default()).prev),
        onClick: ()=>swiper.slidePrev(),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowLeftSLineIcon_default()), {})
    });
}


// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/Skeleton/Skeleton.js + 3 modules
var Skeleton = __webpack_require__(57238);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/swiper@8.4.7/node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(20054);
;// CONCATENATED MODULE: ./containers/banner/banner.tsx







function BannerContainer(param) {
    let { banners , loadingBanner  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (banner_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (banner_module_default()).banner,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (banner_module_default()).bannerContainer,
                children: !loadingBanner ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                    spaceBetween: 10,
                    slidesPerView: 1,
                    children: [
                        banners.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSingle, {
                                    data: item
                                })
                            }, item.id)),
                        banners.length > 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PrevButton, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextButton, {})
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (banner_module_default()).shimmerContainer,
                    children: Array.from(new Array(1)).map((_, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            variant: "rectangular",
                            className: (banner_module_default()).shimmer
                        }, "banner" + idx))
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./containers/shopList/shopList.tsx + 4 modules
var shopList = __webpack_require__(55455);
// EXTERNAL MODULE: ./containers/shopCategoryList/v1.tsx + 1 modules
var v1 = __webpack_require__(29751);
;// CONCATENATED MODULE: ./components/grocery/grocery-data.ts
// export const groceryData = [
//   {
//     id: "01",
//     title: "Build Your Order",
//     description: "Customize your box & set a schedule of recurring deliveries",
//   },
//   {
//     id: "02",
//     title: "Save Even More",
//     description: "Get extra 5-10% off thousands of products an Autoship",
//   },
//   {
//     id: "03",
//     title: "You’re In Control",
//     description:
//       "Edit items, skip or pause Autoship, or place one-time orders anytime",
//   },
// ];
const groceryData = [
    {
        id: "01",
        title: "Monte seu pedido de compra",
        description: "Personalize sua comprar e conta\xe7\xf5es de forma autom\xe1tica e defina um cronograma de entregas recorrentes"
    },
    {
        id: "02",
        title: "Economize ainda mais",
        description: "Economize em milhares de produtos no envio autom\xe1tico e agilize seu processo de compra e cota\xe7\xf5es autom\xe1ticas"
    },
    {
        id: "03",
        title: "Voc\xea no controle",
        description: "Edite itens, pule ou pause o envio autom\xe1tico, ou fa\xe7a pedidos avulsos a qualquer momento"
    }
];

// EXTERNAL MODULE: ./components/grocery/grocery.module.scss
var grocery_module = __webpack_require__(61262);
var grocery_module_default = /*#__PURE__*/__webpack_require__.n(grocery_module);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/@mui+system@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+styled@_oja7ubotzrzctrclxreoqqilcu/node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(18438);
;// CONCATENATED MODULE: ./components/grocery/grocery.tsx







function Grocery() {
    const { t  } = (0,dist_es/* useTranslation */.$G)();
    const isDesktop = (0,useMediaQuery/* default */.Z)("(min-width:1024px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (grocery_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (grocery_module_default()).containerTitle,
                children: t("groceries.delivered.on.your.schedule")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (grocery_module_default()).wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    breakpoints: {
                        0: {
                            slidesPerView: 1
                        },
                        1024: {
                            slidesPerView: 3
                        }
                    },
                    children: groceryData.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            className: index === 1 && isDesktop ? (grocery_module_default()).sideBorder : "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (grocery_module_default()).item,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: (grocery_module_default()).number,
                                        children: item.id
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: (grocery_module_default()).title,
                                        children: t(item.title)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (grocery_module_default()).description,
                                        children: t(item.description)
                                    })
                                ]
                            })
                        }, item.id))
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/becomeSellerBanner/becomeSellerBanner.module.scss
var becomeSellerBanner_module = __webpack_require__(74177);
var becomeSellerBanner_module_default = /*#__PURE__*/__webpack_require__.n(becomeSellerBanner_module);
// EXTERNAL MODULE: ./components/button/primaryButton.tsx
var primaryButton = __webpack_require__(66868);
;// CONCATENATED MODULE: ./components/becomeSellerBanner/becomeSellerBanner.tsx





function BecomeSellerBanner() {
    const { t  } = (0,dist_es/* useTranslation */.$G)();
    const { push  } = (0,router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (becomeSellerBanner_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (becomeSellerBanner_module_default()).textWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: (becomeSellerBanner_module_default()).title,
                    children: t("become.seller.home.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (becomeSellerBanner_module_default()).description,
                    children: t("become.seller.home.description")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primaryButton/* default */.Z, {
                    fullWidth: false,
                    size: "large",
                    onClick: ()=>push("/be-seller"),
                    children: t("become.seller.home.button")
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/dynamic.js
var dynamic = __webpack_require__(65564);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./services/recipe.ts
var recipe = __webpack_require__(73884);
// EXTERNAL MODULE: ./utils/shopAlphabet.ts
var shopAlphabet = __webpack_require__(80462);
;// CONCATENATED MODULE: ./containers/homev1/homev1.tsx



















const VisitedShops = dynamic_default()(()=>__webpack_require__.e(/* import() */ 1499).then(__webpack_require__.bind(__webpack_require__, 71499)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(71499)
            ]
    }
});
function Home() {
    var ref, ref1, ref2, ref3;
    const { t , i18n  } = (0,dist_es/* useTranslation */.$G)();
    const { query  } = (0,router.useRouter)();
    const locale = i18n.language;
    const { isAuthenticated  } = (0,auth_context/* useAuth */.a)();
    const [initial, setInitial] = (0,react.useState)("");
    const { data: shopCategoryList , isLoading: shopCategoryLoading  } = (0,es.useQuery)([
        "shopCategory",
        locale
    ], ()=>category/* default.getAllShopCategories */.Z.getAllShopCategories({
            perPage: 20
        }));
    const { data: banners , isLoading: isBannerLoading  } = (0,es.useQuery)([
        "banners",
        locale
    ], ()=>banner/* default.getAll */.Z.getAll());
    const shopParams = {
        category_id: (query === null || query === void 0 ? void 0 : query.category_id) || undefined,
        initial: (0,shopAlphabet/* shopInitialParam */.xD)(initial)
    };
    const { data , fetchNextPage , hasNextPage , isFetchingNextPage , isLoading , isError , refetch  } = (0,es.useInfiniteQuery)([
        "restaurants",
        locale,
        query === null || query === void 0 ? void 0 : query.category_id,
        initial
    ], (param)=>{
        let { pageParam =1  } = param;
        return shop/* default.getAllRestaurants */.Z.getAllRestaurants(lib_default().stringify({
            page: pageParam,
            perPage: 8,
            ...shopParams
        }));
    }, {
        getNextPageParam: (lastPage)=>{
            if (lastPage.meta.current_page < lastPage.meta.last_page) {
                return lastPage.meta.current_page + 1;
            }
            return undefined;
        }
    });
    const { data: visitedShops  } = (0,es.useQuery)({
        queryKey: [
            "visitedShops",
            locale,
            isAuthenticated
        ],
        queryFn: ()=>shop/* default.getVisitedShops */.Z.getVisitedShops({
                perPage: 10,
                page: 1
            }),
        staleTime: 0
    });
    const { data: recipes , isLoading: isRecipesLoading  } = (0,es.useQuery)({
        queryKey: [
            "recipes",
            locale,
            shopParams === null || shopParams === void 0 ? void 0 : shopParams.category_id
        ],
        queryFn: ()=>{
            return recipe/* default.getAll */.Z.getAll({
                perPage: 10,
                category_id: shopParams === null || shopParams === void 0 ? void 0 : shopParams.category_id
            });
        }
    });
    const restaurants = (data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref.flatMap((item)=>item.data)) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (isBannerLoading || !!(banners === null || banners === void 0 ? void 0 : (ref1 = banners.data) === null || ref1 === void 0 ? void 0 : ref1.length)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (homev1_module_default()).bannerContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerContainer, {
                        banners: (banners === null || banners === void 0 ? void 0 : banners.data) || [],
                        loadingBanner: isBannerLoading
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (homev1_module_default()).shopCategoryListContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1["default"], {
                        data: (shopCategoryList === null || shopCategoryList === void 0 ? void 0 : (ref2 = shopCategoryList.data) === null || ref2 === void 0 ? void 0 : ref2.sort((a, b)=>{
                            return (a === null || a === void 0 ? void 0 : a.input) - (b === null || b === void 0 ? void 0 : b.input);
                        })) || [],
                        loading: shopCategoryLoading
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (homev1_module_default()).shopListContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shopList["default"], {
                        title: t("all.shops"),
                        shops: restaurants,
                        loading: isLoading && !isFetchingNextPage,
                        hasNextPage: hasNextPage,
                        fetchNextPage: fetchNextPage,
                        fetchingNextPage: isFetchingNextPage,
                        compact: true,
                        initial: initial,
                        onInitialChange: (value)=>setInitial((0,shopAlphabet/* normalizeShopInitial */.PK)(value)),
                        error: isError,
                        onRetry: ()=>{
                            refetch();
                        }
                    })
                })
            }),
            !!(visitedShops === null || visitedShops === void 0 ? void 0 : (ref3 = visitedShops.data) === null || ref3 === void 0 ? void 0 : ref3.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (homev1_module_default()).visitedContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VisitedShops, {
                        data: visitedShops === null || visitedShops === void 0 ? void 0 : visitedShops.data
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (homev1_module_default()).groceryContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grocery, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (homev1_module_default()).becomeSellerContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BecomeSellerBanner, {})
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/index.tsx



function HomePage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home, {})
        ]
    });
}


/***/ }),

/***/ 67721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36155);

const bannerService = {
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/banners/paginate", {
            params
        }),
    getById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/banners/".concat(id), {
            params
        }),
    getAllAds: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/banners-ads", {
            params
        }),
    getAdById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/banners-ads/".concat(id), {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (bannerService);


/***/ }),

/***/ 60815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36155);

const categoryService = {
    getAllShopCategories: function() {
        let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/categories/paginate", {
            params: {
                ...params,
                type: "shop"
            }
        });
    },
    getAllSubCategories: function(categoryId) {
        let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("rest/categories/sub-shop/".concat(categoryId), {
            params
        });
    },
    getAllProductCategories: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/".concat(id, "/categories"), {
            params
        }),
    getAllRecipeCategories: function() {
        let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/categories/paginate", {
            params: {
                ...params,
                type: "receipt"
            }
        });
    },
    getById: function(id) {
        let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/categories/".concat(id), {
            params
        });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (categoryService);


/***/ }),

/***/ 73884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36155);

const recipeService = {
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/receipts/paginate", {
            params
        }),
    getById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/receipts/".concat(id), {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (recipeService);


/***/ }),

/***/ 19276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getImage; }
/* harmony export */ });
// import { IMAGE_URL } from "constants/constants";
function getImage(img) {
    if (img) {
        return img;
    } else {
        return "";
    }
}


/***/ }),

/***/ 91644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"bannerSingle_banner__kN2kr","wrapper":"bannerSingle_wrapper__xyQZd"};

/***/ }),

/***/ 74177:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"becomeSellerBanner_container___o7cf","textWrapper":"becomeSellerBanner_textWrapper__iLlPa","title":"becomeSellerBanner_title__CpkMA","description":"becomeSellerBanner_description__6UF8q","imageWrapper":"becomeSellerBanner_imageWrapper__Z2E4L"};

/***/ }),

/***/ 46622:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btn":"carouselArrows_btn__5gqN5","next":"carouselArrows_next__d5Bj1","prev":"carouselArrows_prev__LrJLV"};

/***/ }),

/***/ 80428:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"v1_card__vZ8Zq","active":"v1_active___1OE2","img":"v1_img__Pkq7P","text":"v1_text___e43I"};

/***/ }),

/***/ 61262:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"grocery_container__NZo1q","containerTitle":"grocery_containerTitle__M7vLB","wrapper":"grocery_wrapper__Ql6QM","swiperSlider":"grocery_swiperSlider__egpZm","item":"grocery_item__VqKrj","number":"grocery_number__M5DyR","title":"grocery_title__31Teo","description":"grocery_description__yagGt","sideBorder":"grocery_sideBorder__5Ee8U"};

/***/ }),

/***/ 75166:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"banner_container__ZEunx","banner":"banner_banner__D8D5Q","bannerContainer":"banner_bannerContainer__E7T_G","shimmerContainer":"banner_shimmerContainer__hKSIU","shimmer":"banner_shimmer__tp1rt"};

/***/ }),

/***/ 51603:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search":"homev1_search__bYQIC","bannerContainer":"homev1_bannerContainer__K7ekR","homeActionContainer":"homev1_homeActionContainer__yXAfW","shopCategoryListContainer":"homev1_shopCategoryListContainer__HIWQx","shopListContainer":"homev1_shopListContainer__P4ovs","visitedContainer":"homev1_visitedContainer__wTqr_","recipeListContainer":"homev1_recipeListContainer__Sl1CH","groceryContainer":"homev1_groceryContainer__po3Ay","inviteFriendContainer":"homev1_inviteFriendContainer__DZcDX","becomeSellerContainer":"homev1_becomeSellerContainer__nn93L"};

/***/ }),

/***/ 58532:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"v1_container__4DKRy","title":"v1_title__S4qxw","swiperSlide":"v1_swiperSlide__yiAEb","shimmer":"v1_shimmer__pFUE9","card":"v1_card__dr1_z","active":"v1_active__94rQb","text":"v1_text__aeMs_"};

/***/ }),

/***/ 56377:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(59108);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ArrowLeftSLineIcon = function ArrowLeftSLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M10.828 12l4.95 4.95-1.414 1.414L8 12l6.364-6.364 1.414 1.414z' })
  );
};

var ArrowLeftSLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(ArrowLeftSLineIcon) : ArrowLeftSLineIcon;

module.exports = ArrowLeftSLineIcon$1;


/***/ }),

/***/ 90910:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(59108);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ArrowRightSLineIcon = function ArrowRightSLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z' })
  );
};

var ArrowRightSLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(ArrowRightSLineIcon) : ArrowRightSLineIcon;

module.exports = ArrowRightSLineIcon$1;


/***/ }),

/***/ 81118:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7238,6343,4557,3341,5455,9774,2888,179], function() { return __webpack_exec__(35498); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);